import { useEffect, useState } from 'react';

// Max-widths of screen sizes
export enum ScreenSize {
  Mobile = 800,
  Tablet_sm = 1000,
  Tablet_md = 1300,
  Desktop
}

// TODO: Might need to move to app-common
export function useScreenSize(
  mobile = ScreenSize.Mobile,
  tabletSm = ScreenSize.Tablet_sm,
  tabletMd = ScreenSize.Tablet_md
): ScreenSize {
  const [screenSize, setScreenSize] = useState<ScreenSize>(ScreenSize.Desktop);
  useEffect(() => {
    const update = () => {
      switch (true) {
        case window.innerWidth < mobile:
          setScreenSize(ScreenSize.Mobile);
          break;
        case window.innerWidth < tabletSm:
          setScreenSize(ScreenSize.Tablet_sm);
          break;
        case window.innerWidth < tabletMd:
          setScreenSize(ScreenSize.Tablet_md);
          break;
        default:
          setScreenSize(ScreenSize.Desktop);
          break;
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [mobile, tabletMd, tabletSm]);

  return screenSize;
}
